<div class="nes-w-full nes-flex nes-flex-col nes-items-center nes-mb-16">
  @if(isMobileView) {
    <h2 class="nes-mb-5 nes-text-1200 nes-font-bold nes-text-inverse-subdued">
      {{
        "ADVICE.CUSTOMER_REFERENCE.HEADER_MOBILE" | translate
      }}
    </h2>
  }@else {

    <h2 class="nes-mb-5 nes-text-1200 nes-font-bold nes-text-inverse-subdued">
      {{
        "ADVICE.CUSTOMER_REFERENCE.HEADER"
        | translate: { product: advicedProduct?.name }
      }}
    </h2>
  }
  <p class="nes-text-inverse-subdued">
    {{ "ADVICE.CUSTOMER_REFERENCE.TEXT." + advicedProduct?.name?.toUpperCase()| translate }}
  </p>

  <div class="nes-mt-5 nes-w-full nes-overflow-x-auto nes-overflow-y-hidden nes-pb-4">
    <div
      class="nes-flex nes-gap-8 nes-w-max nes-snap-x nes-snap-mandatory"
    >
      @for (ref of references; track $index) {
        <nes-tile-container
          hover="false"
          border="false"
          background-color="secondary-default"
          class="nes-w-screen nes-max-w-md nes-snap-start"
        >
          <div class="nes-flex nes-items-center nes-mb-10">
            <img
              [src]="'assets/images/customer-references/' + ref.IMAGE"
              alt="Company logo"
              class="nes-mr-5 nes-rounded nes-shadow nes-w-16 nes-h-16"
            />

            <div>
              <p class="nes-text-inverse">{{ ref.COMPANY }}</p>
              <p class="nes-text-inverse-subdued nes-font-bold">
                {{ ref.REFERENCE }}
              </p>
            </div>
          </div>
          <p class="nes-text-inverse">{{ ref.TEXT }}</p>
        </nes-tile-container>
      }
    </div>
  </div>
</div>
